import React from 'react';

import {
    Input,
    Label,
    SubmitButton
} from '$partials/forms';
import { Meta } from '$partials/global';
import { useLocale } from '$contexts/locale.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const LoginPage = () => {
    const { translate: T } = useLocale();

    return (
        <>
            <Meta title='Login' />

            <main
                className='layout-container'
                id='main-content'>
                <article className='py-100'>
                    <form
                        className='flex flex-wrap sm:w-4/6 md:w-1/2 mx-auto px-10 sm:px-15'
                        method='POST'>
                        <div className='w-full mb-10'>
                            <Label
                                htmlFor='password'
                                required={true}>
                                {T('Password')}
                            </Label>
                            <Input
                                name='password'
                                placeholder={T('Enter your password')}
                                required={true}
                                type='password' />
                        </div>

                        <div className='w-full sm:text-right'>
                            <SubmitButton className='bg-orange rounded-button text-white type-style-7 px-20 py-15 ml-auto'>
                                {T('Submit')}
                            </SubmitButton>
                        </div>
                    </form>
                </article>
            </main>
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {};

LoginPage.propTypes = propTypes;

export default LoginPage;
